import { WithAuth } from '../../_hocs/with-auth'
import { SimulationScene } from './_scenes/simulation'

const Simulation = () => {
  return <SimulationScene />
}

export default WithAuth(Simulation, { allowedFor: ['staff', 'tenant'] })
